import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Paywall from "@/pages/Paywall";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, billing, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500" data-testid="loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (!adminOnly && user.role === "admin") return <Navigate to="/admin" replace />;
  if (!adminOnly && billing?.expired) return <Paywall />;
  return children;
}
